import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaTablet } from 'utils/styles/responsive';
import { colors, layout } from 'utils/styles/theme';

const { min } = layout.columns;

interface ContainerProps {
  activeLabel?: boolean;
  hoverTextColor?: string;
}

export const Wrapper = styled.div`
  margin-top: 24px;

  & h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)};
  }

  & h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)};
  }

  & h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)};
  }

  & h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)};
  }

  & h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)};
  }

  p {
    ${({ theme: { locale } }) => setTypography('body', locale)};
    font-weight: 70;
    margin-top: 5px;
  }

  strong {
    font-weight: 135;
  }

  img {
    max-width: 100%;
  }

  ${mediaTablet(`
    margin-top: 34px;

    img {
      max-width: 211px;
    }
  `)}
`;

export const Container = styled.div<ContainerProps>`
  ${({ activeLabel, hoverTextColor }) =>
    activeLabel &&
    css`
      width: fit-content;
      h4:hover,
      span:hover {
        ${hoverTextColor &&
        `color: ${colors[hoverTextColor] ?? hoverTextColor} !important`};
        text-decoration: underline;
        cursor: pointer;
      }
    `};
`;

export const Categories = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 32px;

  margin-top: 16px;

  ${mediaTablet(`
    width: fit-content;
    grid-template-columns: repeat(${min}, 1fr);
    grid-row-gap: 16px;
    grid-column-gap: 56px;

    div {
      width: 299px;
    }
  `)}
`;
